import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectsPage.css';
import FireflyEffect from '../../components/FireflyEffect/FireflyEffect';
import { Helmet } from "react-helmet-async";


function ProjectsPage() {
  
  const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://grauconejo13-portfolio-backend.netlify.app"
    : window.location.origin; // for localhost testing

  return (
    <>
      <FireflyEffect />

<Helmet>
  <title>Projects | Vanessa Victorino</title>
  <meta
    name="description"
    content="Selected works — from real-world applications and school foundations to quirky experiments and interactive interfaces."
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph */}
  <meta property="og:title" content="Featured Projects | Vanessa Victorino" />
  <meta
    property="og:description"
    content="Browse React apps, CodePen demos, data dashboards, and creative builds across tech stacks."
  />
  <meta property="og:url" content={`${baseUrl}/projects`} />
  <meta property="og:type" content="website" />
  <meta property="og:image" content={`${baseUrl}/preview-projects.jpg`} />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Projects by Vanessa Victorino" />
  <meta
    name="twitter:description"
    content="Explore my collection of code-driven and concept-driven creations — web, UI/UX, APIs, and more."
  />
  <meta name="twitter:image" content={`${baseUrl}/twitter-projects.jpg`} />
</Helmet>


      <main className="projects-container">
        <h1>Featured Projects</h1>

        {/* 🎥 Embedded Videos */}
        {/*}
        <section className="video-section">
          <div className="video-container">
            <iframe
              src="#"
              title="Project 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <p>Project 1: Interactive Dashboard</p>
          </div>
          <div className="video-container">
            <iframe
              src="#"
              title="Project 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <p>Project 2: React Web App Walkthrough</p>
          </div>
          <div className="video-container">
            <iframe
              src="#"
              title="Project 3"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <p>Project 3: API Integration Demo</p>
          </div>
        </section>
        */}

        {/* 🧾 Assignment Cards */}
        <section className="assignments-section">
          <h2>Project Showcase</h2>
           <p className="intro-note">
            📝 This site features some of my early projects — from class assignments to personal experiments.
            I'm always building and refining.
          </p>
          <div className="assignment-grid">

          {/* Card 1 */}
            <div className="assignment-card">
              <h3>Codepen Projects</h3>
              <p><p>A glimpse into five projects from Codepen to explore UI, logic, and creative functionality.</p>
</p>
               <Link to="/assignments">
        Browse Assignments →
      </Link>
            </div>

            {/* Card 2 */}
            <div className="assignment-card">
              <h3>JavaScript Quiz App</h3>
              <p>An interactive quiz with scoring logic, timer, and localStorage high scores.</p>
              <a
                href="https://grauconejo13-my-quiz-app.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Play the Quiz →
              </a>
            </div>
            {/* Card 3 */}
            <div className="assignment-card">
              <h3>React Weather Dashboard</h3>
              <p>A weather forecast app using React hooks, the OpenWeather API for data, and Unsplash for dynamic background images.</p>
              <a
                href="https://grauconejo13-my-weather-app.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Check the Weather →
              </a>
            </div>
            
          </div>
        </section>

{/* 🧾 CodePen Cards */}
<section className="assignments-section">
  <h2>CodePen Showcase</h2>
  <div className="assignment-grid">

    {/* Card 1 */}
    <div className="assignment-card">
      <h3>View Count</h3>
      <p>Tracking view counts using Firebase DB</p>
      <a
        href="https://codepen.io/grauconejo13/pen/YPXvrJg"
        target="_blank"
        rel="noopener noreferrer"
      >
        View on CodePen →
      </a>
    </div>

{/* Card 2 */}
<div className="assignment-card">
  <h3>Japanese to English Visual Card</h3>
  <p>A simple visual flashcard tool for learning Japanese vocabulary with English translations.</p>
  <a
    href="https://codepen.io/grauconejo13/pen/RNbLdLB"
    target="_blank"
    rel="noopener noreferrer"
    className="btn-primary"
  >
    View on CodePen →
  </a>
</div>


    {/* Card 3 */}
<div className="assignment-card">
  <h3>Restaurant Ordering Demo</h3>
  <p>Mock restaurant site with menu browsing and simulated online ordering flow.</p>
  <a
    href="https://codepen.io/grauconejo13/pen/WbQZdNK/b69ecf6d44b194786117e282e5c5a21c"
    target="_blank"
    rel="noopener noreferrer"
    className="btn-primary"
  >
    View on CodePen →
  </a>
</div>


  </div>
</section>
         

        {/* 🔗 More Projects */}
        <section className="more-projects">
          <h2>Explore More Projects</h2>
          <p>Want to see more? Check out my demos.</p>
          <a
            href="https://codepen.io/grauconejo13"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
          >
            Visit My Codepen
          </a>
        </section>
      </main>
    </>
  );
}

export default ProjectsPage;
